export class ApiResponseModel {
    status: boolean;
    error: string;
    code: number;
    msg: string;
    data?: any;

    constructor(status: boolean, error: string, code: number, msg: string) {
        this.status = status;
        this.error = error;
        this.code = code;
        this.msg = msg;
    }

    public static fromJson(json: any): ApiResponseModel {
        return new ApiResponseModel(
            json["success"],
            json["error"],
            json["code"],
            json["msg"],
        );
    }
}
export class ApiRadResponseModel {
    status: boolean;
    error: string;
    code: number;
    msg: string;
    data?: any;

    constructor(status: boolean, error: string, code: number, msg: string) {
        this.status = status;
        this.error = error;
        this.code = code;
        this.msg = msg;
    }

    public static fromJson(json: any): ApiRadResponseModel {
        return new ApiRadResponseModel(
            json["status"],
            json["error"],
            json["code"],
            json["msg"],
        );
    }
}

export class JSONMap {
    [key: string]: any
}
